
  // $(document).on('click','#overlay-popup-close',function(){
  //   $("#consolPopup").removeClass("active-popup");
  //   $(".overlay-popup").removeClass("active-popup");
  //   $('#consolPopup').css("display","none");
  //   $('#overlay-popup').css("display","none");
  // });

  // $(document).on('click','#open-cart-offer-main',function(){
  //   $("#consolPopup").addClass("active-popup");
  //   $(".overlay-popup").addClass("active-popup");
  //   $('#consolPopup').css("display","block");
  //   $('#overlay-popup').css("display","block");
  // });

  $(document).on('click','#overlay-popup-close',function(){
    $("#consolPopup").removeClass("active-popup");
    $(".overlay-popup").removeClass("active-popup");
    $('#consolPopup').css("display","none");
    $('#overlay-popup').css("display","none");
  });

  $(document).on('click','#open-cart-offer-main',function(){
    var data_product = $(this).attr("data-item");
    var item_grid = $("div").find(`[data-product='${data_product}']`);
    $(item_grid).css("display","none");
    $("#consolPopup").addClass("active-popup");
    $(".overlay-popup").addClass("active-popup");
    $('#consolPopup').css("display","block");
    $('#consolPopup').css("max-width","550px");
    $('.card-wrapper.product-card-wrapper.underline-links-hover').css("max-width", "100%");
    $('#overlay-popup').css("display","block");
  });


  $(document).on('click','.ad_to_cart',function(){ 
  var ID = $(this).attr("data-id");
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  dataType: 'json', 
  catch: false,
  async: false,
  data: {
    quantity: 1,
    id: ID
  },
   success: function (data) { 

    $('#CartCount span:first').text(data.quantity);
   } 
   });
  }) 